import '../styles/fonts.less'
import '../styles/theme.scss'

import './initializers/initArgentStuff'

import {initAccountRecoveryToggle} from './initializers/initAccountRecoveryToggle'
import {initAddressForms} from './initializers/initAddressForms'
import {initAjaxinate} from './initializers/initAjaxinate'
import {initBookAppointmentPage} from './initializers/initBookAppointmentPage'
import {initCartManager} from './initializers/initCartManager'
import {initProductItem} from './initializers/initProductItem'
import {initSearchForm} from './initializers/initSearchForm'
import {initSlideshows} from './initializers/initSlideshows'
import {initFormValidation} from './initializers/initFormValidation'
import {initInstagramFeed} from './initializers/initInstagramFeed'
import {initMobileBrowser100vhFix} from './initializers/initMobileBrowser100vhFix'
import {initNewsletterPopup} from './initializers/initNewsletterPopup'
import {initNewsletterFooter} from './initializers/initNewsletterFooter'
import {initSlippy} from './initializers/initSlippy'
import {initVideoGif} from './initializers/initVideoGif'
import {initVideoJazz} from './initializers/initVideoJazz'
import {initHeader} from './initializers/initHeader'
import {initStylingSession} from './initializers/initStylingSession'
import {initProductPage} from './initializers/initProductPage'
import {initOrderForm} from './initializers/initOrderForm'
import {initCartPage} from './initializers/initCartPage'

initCartManager()
initMobileBrowser100vhFix()
initSlippy()
initHeader()
initNewsletterPopup()
initSearchForm()
initVideoGif()
initVideoJazz()
initProductItem()
initFormValidation()
initInstagramFeed()
initNewsletterFooter()
initStylingSession()
initAccountRecoveryToggle()
initAddressForms()
initAjaxinate()
initSlideshows()
initBookAppointmentPage()
initProductPage()
initOrderForm()
initCartPage()